export function getUriForResource(widgetDefinitionId, resource) {
    // If the resoruce is a full uri, just return it as is
    if (resource.toLocaleLowerCase().startsWith("http") || resource.toLocaleLowerCase().startsWith("data:")) {
        return resource;
    }
    else {
        // replace '.' in id to '-' to convert to dir name under wwwroot
        return widgetDefinitionId.replace(/\./g, "-") + "/" + resource;
    }
}
export function getDisplayResourceNameFromID(id) {
    let re = /\./gi;
    return id.replace(re, "_") + "_title";
}
export function getAttributionResourceNameFromID(id) {
    let re = /\./gi;
    return id.replace(re, "_") + "_attribution";
}
